/* eslint-disable @typescript-eslint/no-empty-function */
export const noop = () => {}

export const asyncNoop = async () => {}
